import { render, staticRenderFns } from "./Shareholder-assignement-remove.vue?vue&type=template&id=23799d88"
import script from "./Shareholder-assignement-remove.vue?vue&type=script&lang=js"
export * from "./Shareholder-assignement-remove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports